import React from 'react'
import { Stack } from 'react-bootstrap'

function Section({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <section className="py-5 border-top ">
      <Stack gap={3}>
        <h3 className=" text-uppercase">{title}</h3>
        {children}
      </Stack>
    </section>
  )
}

export default Section
